export const AUTHORITY_DASHBOARD: string = 'dashboard';
export const AUTHORITY_DOSSIER_LIST: string = 'dossiers';
export const AUTHORITY_DOSSIER_LIST_CHANNEL: string = 'channel-filtered';
export const AUTHORITY_DOSSIER_DETAILS: string = 'details';
export const AUTHORITY_APPOINTMENTS_LIST: string = 'appointments';
export const AUTHORITY_DOSSIER_WORKING_LIST: string = 'dossier-workings';
export const AUTHORITY_DOSSIER_WORKING_DETAILS: string = 'details';
export const AUTHORITY_NEW_APPOINTMENT: string = 'new-appointment';
export const AUTHORITY_NEW_REPAIR_APPOINTMENT: string = 'new-repair-appointment';
export const AUTHORITY_APPOINTMENTS_DETAILS: string = 'details';
export const AUTHORITY_NEW_DOSSIER: string = 'new-dossier';
export const AUTHORITY_DELIVERY: string = 'delivery';
export const AUTHORITY_WORKING_LOGS: string = 'logs';
export const AUTHORITY_GLASS_LIST: string = 'glass';
export const AUTHORITY_GLASS_LIST_CHANNEL: string = `channel-${AUTHORITY_GLASS_LIST}`;
export const AUTHORITY_GLASS_DETAILS: string = 'details';
export const AUTHORITY_DOSSIER_HISTORY: string = 'history';
export const AUTHORITY_DOSSIER_SIGN: string = 'sign-';
export const AUTHORITY_DOSSIER_SIGN_REDELIVERY: string = `${AUTHORITY_DOSSIER_SIGN}redelivery`;
export const AUTHORITY_DOSSIER_SIGN_REDELIVERY_ANOTHER_COMMODITY: string = `${AUTHORITY_DOSSIER_SIGN}redelivery-another-commodity`;
export const AUTHORITY_DOSSIER_SIGN_ACCEPTANCE: string = `${AUTHORITY_DOSSIER_SIGN}acceptance`;
export const AUTHORITY_QUOTATIONS_LIST: string = 'operations';
export const AUTHORITY_QUOTATIONS_DETAILS: string = 'details';
export const AUTHORITY_WORKING_LOGS_DETAILS: string = 'details';
export const AUTHORITY_CONSULTATION: string = 'consultation';
export const AUTHORITY_GLASS_IMPORT_PRICELIST: string = 'import-pricelist';
export const FLOTTA_POOL:string='flotta-pool';
export const VEHICLES_LIST = 'vehicles-list';
export const BACKOFFICE_STATIC = 'backoffice-static';
export const AUTHORITY_SUPPLEMENT_LIST: string = 'supplement';
